/**
 * 图表组件注册纯函数。
 */

import type { TChartType } from '@dbl/core/chart';
import { CHART_TRAG_CARD_TYPE_SET } from './constants';

/**
 * 判断 chart_type 是否应使用 ChartTragCard 渲染。
 *
 * @core DashboardLayout/index 卡片路由分支；放 index.tsx 内联 Set 无法被 WorkBench 等复用且难测。
 * 
 * 持续观察的是 isChartTragCardType 是否 Dashboard 独占。
 */
export function isChartTragCardType(chartType: TChartType): boolean {
  return CHART_TRAG_CARD_TYPE_SET.has(chartType);
}
